export var HTTPRequestMethod;
(function (HTTPRequestMethod) {
    HTTPRequestMethod["Delete"] = "DELETE";
    HTTPRequestMethod["Get"] = "GET";
    HTTPRequestMethod["Patch"] = "PATCH";
    HTTPRequestMethod["Post"] = "POST";
    HTTPRequestMethod["Put"] = "PUT";
})(HTTPRequestMethod || (HTTPRequestMethod = {}));
export var SaveStatus;
(function (SaveStatus) {
    SaveStatus[SaveStatus["Failed"] = -1] = "Failed";
    SaveStatus[SaveStatus["Unsaved"] = 0] = "Unsaved";
    SaveStatus[SaveStatus["Saving"] = 1] = "Saving";
    SaveStatus[SaveStatus["Saved"] = 2] = "Saved";
})(SaveStatus || (SaveStatus = {}));
export var ContentType;
(function (ContentType) {
    ContentType["Markdown"] = "markdown";
    ContentType["PlainText"] = "plaintext";
    ContentType["HTML"] = "html";
    ContentType["Audio"] = "audio";
    ContentType["Empty"] = "none";
})(ContentType || (ContentType = {}));
/** Array containing the channels that are checked for available agents threshold */
export const conversationChannelsToCheckForThreshold = [
    'email',
    'pstn_phone',
    'contact_form',
    'widget_chat',
];
/** Map of conversation channels and various attributes. */
export const conversationChannelAttributes = new Map([
    [
        'callback',
        {
            prettyName: 'Callback',
            icon: 'callback',
        },
    ],
    [
        'contact_form',
        {
            prettyName: 'Contact Form',
            icon: 'mail',
        },
    ],
    [
        'email',
        {
            prettyName: 'Email',
            icon: 'mail',
        },
    ],
    [
        'facebook_messenger',
        {
            prettyName: 'Facebook Messenger',
            icon: 'facebook-messenger',
        },
    ],
    [
        'messenger',
        {
            prettyName: 'Messenger',
            icon: 'messenger',
        },
    ],
    [
        'pstn_phone',
        {
            prettyName: 'Phone',
            icon: 'phone',
        },
    ],
    [
        'sms',
        {
            prettyName: 'SMS',
            icon: 'phone',
        },
    ],
    [
        'telegram',
        {
            prettyName: 'Telegram',
            icon: 'chat',
        },
    ],
    [
        'twitter',
        {
            prettyName: 'Twitter',
            icon: 'twitter',
        },
    ],
    [
        'voicemail',
        {
            prettyName: 'Voicemail',
            icon: 'voicemail',
        },
    ],
    [
        'whats_app',
        {
            prettyName: 'WhatsApp',
            icon: 'whatsapp',
        },
    ],
    [
        'widget_chat',
        {
            prettyName: 'Chat',
            icon: 'chat',
        },
    ],
]);
